import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { DatetimeRangePipe } from './datetime-range/datetime-range.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [DatetimeRangePipe],
  exports: [DatetimeRangePipe],
  providers: [DatePipe],
})
export class Bau365UiDateformattingModule {}
